import React from 'react';
import cls from './BoardTaskSkeleton.module.css';

export function TaskBoardSkeleton() {
    return (
        <div className={cls.SkeletonContainer}>
            <div className={cls.SkeletonBoardItem}></div>
            <div className={cls.SkeletonBoardItem}></div>
            <div className={cls.SkeletonBoardItem}></div>
            <div className={cls.SkeletonBoardItem}></div>
            <div className={cls.SkeletonBoardItem}></div>
        </div>
    );
}
